/* @flow */
import AppLinkActions from 'actions/AppLinkActions';
import Button from 'components/ButtonDeprecated';
import Field from 'components/Field';
import FormSingle from 'components/FormSingle';
import Input from 'components/Input';
import Label from 'components/Label';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';

import './styles/TextAppLinkForm.scss';

type Props = {
  handlePlanLinkSubmit?: () => void,
  hasMobilePlanLink?: boolean,
};

type State = {
  error: string,
  phoneNumber: string,
  submitting: boolean,
  valid: boolean,
};

export class TextAppLinkForm extends React.Component<Props, State> {
  state: State = {
    error: '',
    phoneNumber: '',
    submitting: false,
    valid: false,
  };

  handlePhoneNumberChange = (event: SyntheticEvent<>) => {
    this.setState({
      error: '',
      // $FlowFixMe
      phoneNumber: event.target.value,
      // $FlowFixMe
      valid: event.target.checkValidity(),
    });
  };

  handlePhoneNumberBlur = (event: SyntheticEvent<>) => {
    // $FlowFixMe
    if (event.target.value !== '') {
      // $FlowFixMe
      const valid = event.target.checkValidity();

      this.setState({ valid });

      if (!valid) {
        this.setState({ error: 'Invalid phone number' });
      }
    }
  };

  handleSubmit = (event: SyntheticEvent<*>) => {
    event.preventDefault();

    const onSuccess = () => {
      ToastActions.showSuccessToast(`Download link sent to ${this.state.phoneNumber}`);
      this.setState({
        phoneNumber: '',
        submitting: false,
        valid: false,
      });

      if (this.props.handlePlanLinkSubmit) {
        this.props.handlePlanLinkSubmit();
      }
    };

    const onError = () => {
      ToastActions.showErrorToast('Download link not sent. Please try again later.');
      this.setState({ submitting: false });
    };

    this.setState({ submitting: true });

    if (this.props.hasMobilePlanLink) {
      AppLinkActions.sendIndividualPlanAppLink(this.state.phoneNumber).then(onSuccess, onError);
    } else {
      AppLinkActions.sendLink(this.state.phoneNumber).then(onSuccess, onError);
    }
  };

  render() {
    return (
      <div className="TextAppLinkForm">
        <form className="TextAppLinkForm-form" onSubmit={this.handleSubmit}>
          <Field error={this.state.error}>
            <Label hidden>Phone number</Label>
            <FormSingle reset="mobile">
              <Input
                type="tel"
                pattern="\+?1?[- .]?\(?\d{3}\)?[- .]?\d{3}[- .]?\d{4}"
                placeholder="(555) 555-5555"
                value={this.state.phoneNumber}
                onBlur={this.handlePhoneNumberBlur}
                onChange={this.handlePhoneNumberChange}
                autoFocus
                required
              />
              <Button
                type="submit"
                level="primary"
                size="small"
                disabled={!this.state.valid || this.state.submitting}>
                Text me a link
              </Button>
            </FormSingle>
          </Field>
        </form>
      </div>
    );
  }
}

export default TextAppLinkForm;
